export default __webpack_public_path__ + "static/media/le_montmini.b2ede354.jpg";